"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H1 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H1",
  componentId: "tkst7d-0"
})(_templateObject());
H1.propTypes = _Heading.default.propTypes;
H1.defaultProps = (0, _extends2.default)({}, _Heading.default.defaultProps, {
  tagName: 'h1'
});
H1.displayName = 'H1';
var _default = H1;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/elements/headings/H1.js
// module id = 139
// module chunks = 5 6